import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Customers",
    subheader:
      "Pass a customer email with any payment link and we'll dynamically look them up in within your existing Stripe customers. If found we'll associate the new checkout session with them."
  }),
  rows: [
    {
      title: {
        value: "Dynamic look up",
        tooltip:
          "Pass an email parameter to start a checkout session for a specific customer."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Lock to a customer",
        tooltip:
          "Ensure a payment link can only be associated with one customer."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
